export default __webpack_public_path__ + "990bff69e2933366db818ebdc64c05e6.woff";